import PropTypes from 'prop-types';
import LinearProgress from '@mui/material/LinearProgress';
import MovingComponent from 'react-moving-text';
import { useState } from 'react';
import { Box, Typography } from '@mui/material';

IndeterminateLoading.propTypes = {
  sx: PropTypes.object,
  message: PropTypes.string
};

export default function IndeterminateLoading({ sx, message }) {
  const animations = ['fadeIn', 'fadeOut'];

  const [animationIndex, setAnimationIndex] = useState(0);
  const [animationType, setAnimationType] = useState(animations[0]);

  const handleChainAnimation = () => {
    setAnimationIndex(animationIndex + 1);
    setAnimationType(animations[animationIndex + 1]);
  };
  return (
    <Box sx={sx}>
      <LinearProgress color="primary" />
      <MovingComponent
        onAnimationEnd={handleChainAnimation}
        type={animationType}
        duration="1000ms"
        timing="linear"
        fillMode="forwards"
        iteration="infinite"
      >
        <Typography variant="h4" align="center" color="primary">
          {message}
        </Typography>
      </MovingComponent>
    </Box>
  );
}
